import React, { useState } from "react";
import Header from "../../components/header";
import { MdSearch } from "react-icons/md";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const SupportMain = ({ onSearch }) => {
  const [query, setQuery] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const target = document.getElementById("help-library");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (typeof onSearch === "function") onSearch(query);
  };

  return (
    <>
      <style>{`
				.support-hero-input::placeholder { color: rgba(255,255,255,0.5); }
				@media (max-width: 767px) {
					.support-hero { padding: 40px 20px 80px !important; }
					.support-hero h1 { font-size: 44px !important; }
				}
			`}</style>

      <section
        style={{
          background: "#132A22",
          width: "100%",
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Header />

        {/* Decorative background pattern — soft organic shapes */}
        <svg
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            opacity: 0.06,
          }}
        >
          <defs>
            <pattern
              id="support-hero-pattern"
              x="0"
              y="0"
              width="240"
              height="240"
              patternUnits="userSpaceOnUse"
            >
              <ellipse
                cx="40"
                cy="60"
                rx="46"
                ry="34"
                fill="none"
                stroke="#86C7A8"
                strokeWidth="1"
              />
              <ellipse
                cx="180"
                cy="50"
                rx="32"
                ry="42"
                fill="none"
                stroke="#86C7A8"
                strokeWidth="1"
              />
              <ellipse
                cx="120"
                cy="150"
                rx="50"
                ry="38"
                fill="none"
                stroke="#86C7A8"
                strokeWidth="1"
              />
              <ellipse
                cx="30"
                cy="200"
                rx="28"
                ry="36"
                fill="none"
                stroke="#86C7A8"
                strokeWidth="1"
              />
              <ellipse
                cx="210"
                cy="210"
                rx="40"
                ry="30"
                fill="none"
                stroke="#86C7A8"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="url(#support-hero-pattern)"
          />
        </svg>

        <div
          className="support-hero"
          style={{
            position: "relative",
            padding:
              "clamp(56px, 7vw, 110px) clamp(20px, 5.56vw, 80px) clamp(80px, 9vw, 140px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "clamp(20px, 2.5vw, 36px)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#86C7A8",
                display: "inline-block",
              }}
            />
            <span
              style={{
                ...geistMono,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: 1,
                letterSpacing: "0.1em",
                color: "#86C7A8",
                textTransform: "uppercase",
              }}
            >
              Help Centre
            </span>
          </div>

          <h1
            style={{
              ...instrumentSerif,
              fontWeight: 400,
              fontSize: "clamp(44px, 6.25vw, 88px)",
              lineHeight: 1.02,
              letterSpacing: "-0.015em",
              color: "#FFFFFF",
              margin: 0,
              maxWidth: "min(820px, 100%)",
            }}
          >
            How can we help you today?
          </h1>

          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(14px, 1.25vw, 18px)",
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.72)",
              margin: 0,
              maxWidth: "min(560px, 100%)",
            }}
          >
            Get support, find answers, report issues, or speak directly with our
            team.
          </p>

          <form
            onSubmit={submit}
            style={{
              width: "100%",
              maxWidth: "560px",
              marginTop: "clamp(8px, 1vw, 16px)",
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdSearch
              size={20}
              style={{
                position: "absolute",
                left: "20px",
                color: "rgba(255,255,255,0.55)",
                pointerEvents: "none",
              }}
            />
            <input
              type="text"
              className="support-hero-input"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search help articles, e.g 'reset PIN' or 'loan repayment'"
              style={{
                ...raleway,
                width: "100%",
                height: "60px",
                padding: "0 24px 0 52px",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.14)",
                borderRadius: "10px",
                fontSize: "15px",
                color: "#FFFFFF",
                outline: "none",
                boxSizing: "border-box",
                WebkitAppearance: "none",
                appearance: "none",
              }}
            />
          </form>
        </div>
      </section>
    </>
  );
};

export default SupportMain;
